import { changeModalStep, openModal } from '~shared/actions/modal';
import { getDoctorFromMostRecentPrescriptions } from '~shared/features/prescriptions/selectors/getDoctorFromMostRecentPrescriptions';
import { connect } from '~shared/store';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';
import CardFinderInfoModal from './CardFinderInfoModal';

const mapStateToProps = (state: ReduxStateShared) => {
  return { ...state.modal, doctor: getDoctorFromMostRecentPrescriptions(state) };
};

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => {
  return {
    onClose: () => {
      dispatch(openModal('ONBOARDING_MODAL'));
      dispatch(changeModalStep(1, 'ONBOARDING_MODAL'));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CardFinderInfoModal);
